import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { filter, first, map, tap } from 'rxjs/operators';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { Lead } from '../../models/lead.model';
import { ToastService } from '@capturum/ui/api';
import { ProposedLead } from '@features/leads/models/proposed-lead.model';
import { AsyncPipe, KeyValuePipe, NgTemplateOutlet } from '@angular/common';

interface StatusDetails {
  title?: string;
  main?: {
    name?: string;
    address?: string;
    city?: string;
  };
  extra?: {
    phone?: string;
    email?: string;
    room?: string;
  };
}

interface ProposalResponseData {
  hasError: boolean;
  response: any;
}

@Component({
    selector: 'app-proposal-status-lead',
    templateUrl: './proposal-status-lead.component.html',
    styleUrls: ['./proposal-status-lead.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [AsyncPipe, KeyValuePipe, NgTemplateOutlet, TranslateModule]
})
export class ProposalStatusLeadComponent implements OnInit {
  public tokenIsExpired = false;
  public errorMessage: string;
  public statusFields$: Observable<StatusDetails>;
  public redirectInfo: {
    redirect: boolean;
    returnUrl: string;
    toast: string;
  };

  constructor(
    private readonly route: ActivatedRoute,
    private readonly translateService: TranslateService,
    private readonly router: Router,
    private readonly toastService: ToastService
  ) {}

  public ngOnInit(): void {
    this.statusFields$ = this.route.data.pipe(
      first(),
      filter((data) => {
        console.log(data);

        return !!data.proposalData;
      }),
      tap(({ proposalData }) => {
        const response: ProposedLead = proposalData?.response;
        const { redirect, returnUrl, toast } = response;

        this.redirectInfo = {
          redirect,
          returnUrl,
          toast,
        };
      }),
      map(({ proposalData }) => {
        const { response, hasError, status } = proposalData;
        const { room_type, lead } = response;

        if (hasError) {
          if (response.error?.data?.error) {
            this.errorMessage = response.error?.data?.error;
          } else {
            this.tokenIsExpired = true;

            if (this.redirectInfo.redirect) {
              this.router.navigate([this.redirectInfo.returnUrl]);

              const titleToast = this.translateService.instant('toast.warning.title');

              this.toastService.info(titleToast, this.redirectInfo.toast, { closable: true, life: 50000 });
            }

            return {
              title: '',
              main: {},
              extra: {},
            };
          }
        } else {
          return {
            title: this.translateService.instant(`LeadPortal.lead.proposal-status.${status}.title`),
            main: this.getGroup(room_type, lead, status, 'main'),
            extra: this.getGroup(room_type, lead, status, 'extra'),
          };
        }
      })
    );
  }

  public getGroup(roomType: string, lead: Partial<Lead>, status: string, groupType: string): any {
    if (groupType !== 'main') {
      return status !== 'reject'
        ? {
            phone: lead.phone,
            email: lead.email,
            room: roomType,
          }
        : {
            room: roomType,
          };
    } else {
      return status !== 'reject'
        ? {
            name: lead.name,
            address: lead.address,
            city: lead.city,
          }
        : {
            city: lead.city,
          };
    }
  }
}
